import { io } from "socket.io-client";

let socket;

export const connectSocket = (url, options) => {
  // Clean up any existing socket completely
  if (socket) {
    socket.removeAllListeners();
    if (socket.connected) {
      socket.disconnect();
    }
    socket = null;
  }

  socket = io(url, options);

  // Global socket event logger - logs ALL incoming events
  socket.onAny((eventName, ...args) => {
    console.log(`🔊 Socket Event: ${eventName}`, {
      event: eventName,
      data: args,
      timestamp: new Date().toISOString(),
    });
  });
};

export const disconnectSocket = () => {
  if (socket) socket.disconnect();
};

const unsubscribeFromSocketEvent = (eventName, socket) => {
  if (!socket) {
    return;
  }
  socket.removeAllListeners(eventName);
};

const subscribeToSocketEvent = (eventName, callback, allowMultiple) => {
  if (!socket || !callback) {
    return;
  }

  if (!allowMultiple && socket.listeners(eventName).length >= 1) {
    return;
  }

  socket.on(eventName, callback);
};

export const createSocketSubscription = (eventName) => ({
  subscribe: (callback, allowMultiple = false) =>
    subscribeToSocketEvent(eventName, callback, allowMultiple),
  unsubscribe: () => unsubscribeFromSocketEvent(eventName),
});

export const sendSocketEvent = (eventName, data) => {
  if (!socket) return;
  socket.emit(eventName, data);
};

export const sendSocketEventWithAck = (eventName, data, timeoutMs = 8000) =>
  new Promise((resolve, reject) => {
    if (!socket) {
      reject(new Error(`Socket is not connected for event: ${eventName}`));
      return;
    }

    let hasSettled = false;

    const timeoutTimer = setTimeout(() => {
      if (hasSettled) return;
      hasSettled = true;
      reject(new Error(`Socket ack timed out for event: ${eventName}`));
    }, timeoutMs);

    socket.emit(eventName, data, (acknowledgement) => {
      if (hasSettled) return;
      hasSettled = true;
      clearTimeout(timeoutTimer);
      resolve(acknowledgement);
    });
  });
